import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ toastOptions, ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        ...toastOptions,
        classNames: {
          toast: "font-sans",
          title: "font-sans",
          success: "!text-green-600",
          error: "!text-red-600",
          description: "font-sans",
          actionButton: "font-sans",
          cancelButton: "font-sans",
          closeButton: "font-sans",
          ...toastOptions?.classNames,
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
